export default __webpack_public_path__ + "static/media/map.d5a3fdd0.svg";